// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAnimate from 'vue-animate-scroll'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/iconfont/iconfont.scss'
import './styles/index.scss'
import '@/utils/globalComponents'
import { baseMessage } from '@/utils/message'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
Vue.use(ElementUI)
/* jquery */
// import 'jquery'

/* bootstrap */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* 重置css */
import './assets/css/reset.css'
import './assets/css/common.css'
// import './assets/css/quill-better-table.css'

import utils from './utils'

import { FormatDate } from '@/filters';
import { FormatTime } from '@/filters';
Vue.filter("FormatDate", FormatDate);
Vue.filter("FormatTime", FormatTime);

Vue.config.productionTip = false
Vue.prototype.$baseMessage = baseMessage
Vue.prototype.$axios = axios
Vue.prototype.utils = utils

Vue.use(VueAnimate)


// 路由拦截
const WHITE_LIST = ['home','login','service','products','productsDetail','needs','needsDetail','news','newsDetail','organ','aboutUs','register']
router.beforeEach((to, from, next) => {
  // NProgress.start()
  if (!store.state.system.token) {
    if (WHITE_LIST.filter((v) => v === to.name).length) {
      next()
    } else {
      next({
        path:'/home'
      })
    }
  } else {
    if (WHITE_LIST.filter((v) => v === to.name).length) {
      next()
    } else {
      next()
    }
  }
})


router.afterEach((to, from) => {
  store.dispatch('getBreadcrum', to)
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
